export default __webpack_public_path__ + "static/media/graphic-12.54974c34.png";